import { Link } from 'react-router-dom';

export default function HeroSection() {
  return (
    <section className="relative w-full h-[420px] md:h-[600px] overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Korean%20manhwa%20webtoon%20art%20collage%20with%20vibrant%20characters%2C%20warm%20amber%20and%20dark%20tone%2C%20dramatic%20lighting%2C%20Korean%20comic%20style%2C%20heroic%20figures%20silhouettes%2C%20atmospheric%20composition%2C%20digital%20illustration%2C%20cinematic%20mood&width=1800&height=900&seq=hanman-hero-bg&orientation=landscape"
        alt="韩漫大全 - 韩国漫画免费阅读"
        title="韩漫网站 韩国漫画免费 韩漫网址 韩漫大全"
        className="absolute inset-0 w-full h-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/30 to-black/60"></div>

      <div className="relative z-10 flex flex-col items-center justify-center h-full px-4 text-center">
        <h1 className="text-3xl md:text-5xl lg:text-6xl font-bold font-heading text-background-50 mb-4 leading-tight">
          韩国漫画免费阅读
        </h1>
        <p className="text-base md:text-lg text-background-50/70 max-w-2xl mb-8">
          访问<strong>韩漫网站</strong>，通过<strong>韩漫网址</strong>便捷导航，
          浏览<strong>韩漫大全</strong>合集，每日更新热门韩漫，满足您对高质量漫画的阅读欲望
        </p>
        <Link
          to="/category/love"
          className="whitespace-nowrap cursor-pointer bg-background-50/15 backdrop-blur-sm text-background-50 border border-background-50/25 px-8 py-3 rounded-full text-sm font-medium hover:bg-background-50/25 transition-all duration-300"
        >
          立即探索韩漫大全 <i className="ri-arrow-right-line ml-1 w-4 h-4 inline-flex items-center justify-center"></i>
        </Link>
      </div>
    </section>
  );
}